/**
 * @file 申请试用页面
 * @author wangzhuang
 */

import {rcAjax} from '../util';
import {GET_LEADER_BOARD} from './ActionTypes';

export function fetchLeaderBoard(dispatch, obj) {
    return rcAjax('POST', '/xiapi/api/v1/robustness/getLeaderBoard', {}, obj, data => {
        dispatch({type: GET_LEADER_BOARD, data: data.data});
    });
}



// WEBPACK FOOTER //
// ./src/actions/luBangAction.js